import angular from 'angular';
import moment from 'moment';
import { PlanosModalService } from '../modal/planos/planos.modal.service';
import { CancelamentoModalService } from '../modal/cancelamento/cancelamento.modal.service';
import { SuspensaoModalService } from '../modal/suspensao/suspensao.modal.service';
import { ProrrogacaoModalService } from '../modal/prorrogacao/prorrogacao.modal.service';
import { TrocaModalService } from '../modal/troca/troca.modal.service';
import { ReativacaoModalService } from '../modal/reativacao/reativacao.modal.service';
import { MeurhBeneficiosService } from '../beneficios.service';
import { SituacaoBeneficioEnum, TipoBeneficios, TipoBeneficiosEnum } from '../beneficios.enum';
import { TipoSolicitacaoEnum } from '../../../../../shared/enums/TipoSolicitacaoEnum';
import {
    IBeneficiario,
    IBeneficioTrabalhador,
    IBeneficioTrabalhadorDetalhado,
    ITrabalhadorDependente
} from '../model/beneficios.model';
import { ISolicitacaoBeneficio } from '../model/solicitacao.beneficio.model';

type ITiposDeBeneficios = {
    [key in TipoBeneficiosEnum]: {
        solicitacoes: (ISolicitacaoBeneficio & IBeneficiario)[],
        beneficiostrabalhador: IBeneficioTrabalhadorDetalhado[]
    }
};

export class MeurhBeneficiosIndexController {

    static $inject = [
        '$rootScope',
        '$scope',
        '$state',
        'PlanosModalService',
        'CancelamentoModalService',
        'SuspensaoModalService',
        'ProrrogacaoModalService',
        'TrocaModalService',
        'ReativacaoModalService',
        'MeurhBeneficiosService'
    ];

    public busy = false;
    public loading = false;
    public colaborador: string;
    public situacaoBeneficioEnum = SituacaoBeneficioEnum;
    public tipoSolicitacaoEnum = TipoSolicitacaoEnum;
    public tiposDeBeneficiosConst = TipoBeneficios;
    public tiposDeBeneficiosDisponiveis: TipoBeneficiosEnum[] = [];
    public tiposDeBeneficiosKeys: TipoBeneficiosEnum[] = [];
    public tiposDeBeneficios = this.setTiposBeneficios();
    public switchAtivos = true;
    public filterAtivos: {} = {
        situacaoBeneficio: SituacaoBeneficioEnum.ATIVO
    };
    public inclusaoBtnVisibility = {
        visible: false,
        items: {} as { [key in TipoBeneficiosEnum]: boolean }
    };

    constructor(
        public $rootScope: angular.IRootScopeService & {
            liberadoTela: (arg: string) => boolean,
            temPermissao: (arg: string) => boolean,
            session: any
        },
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public PlanosModalService: PlanosModalService,
        public CancelamentoModalService: CancelamentoModalService,
        public SuspensaoModalService: SuspensaoModalService,
        public ProrrogacaoModalService: ProrrogacaoModalService,
        public TrocaModalService: TrocaModalService,
        public ReativacaoModalService: ReativacaoModalService,
        public MeurhBeneficiosService: MeurhBeneficiosService
    ) {}

    $onInit() {
        this.loading = true;
        const reqTiposDeBeneficios = this.MeurhBeneficiosService.getTiposBeneficios(this.$rootScope.session.entities.empresa.empresa);
        const reqBeneficiosTrabalhador = this.MeurhBeneficiosService.getBeneficiosTrabalhador(this.colaborador);
        const reqInclusoesBeneficio = this.MeurhBeneficiosService.getInclusoesBeneficio(this.colaborador, 0);
        const reqCancelamentoBeneficio = this.MeurhBeneficiosService.getCancelamentosBeneficio(this.colaborador, 0);
        const reqSuspensaoBeneficio = this.MeurhBeneficiosService.getSuspensoesBeneficio(this.colaborador, 0);
        const reqProrrogacaoBeneficio = this.MeurhBeneficiosService.getProrrogacoesBeneficio(this.colaborador, 0);
        const reqTrocaBeneficio = this.MeurhBeneficiosService.getTrocasBeneficio(this.colaborador, 0);
        const reqReativacaoBeneficio = this.MeurhBeneficiosService.getReativacoesBeneficio(this.colaborador, 0);
        Promise.all([
            reqTiposDeBeneficios,
            reqBeneficiosTrabalhador,
            reqInclusoesBeneficio,
            reqCancelamentoBeneficio,
            reqSuspensaoBeneficio,
            reqProrrogacaoBeneficio,
            reqTrocaBeneficio,
            reqReativacaoBeneficio
        ]).then((values) => {
            this.loading = false;
            const solicitacoes = [
                ...values[2],
                ...values[3],
                ...values[4],
                ...values[5],
                ...values[6],
                ...values[7],
            ];
            this.setTiposDeBeneficios(values[1], solicitacoes);
            this.tiposDeBeneficiosDisponiveis = values[0];
            this.inclusaoBtnVisibility = this.setInclusaoBtnVisible(values[0]);
            this.$scope.$applyAsync();
        });
    }

    openPlanosModal(beneficioTrabalhador: IBeneficioTrabalhadorDetalhado) {
        const modal = this.PlanosModalService.open({
            beneficio: beneficioTrabalhador.beneficio,
            tipoBeneficio: beneficioTrabalhador.tipobeneficiointerno.tipobeneficiointerno,
            editable: false
        });
        modal.result.then(() => {/**/}).catch(() => {/**/});
    }

    openHistorico(beneficioTrabalhador: IBeneficioTrabalhadorDetalhado) {
        this.$rootScope.$broadcast('beneficios_historico_open', { beneficioTrabalhador });
    }

    openModal(tipoSolicitacao: TipoSolicitacaoEnum, beneficioTrabalhador: IBeneficioTrabalhadorDetalhado) {
        let modal: angular.ui.bootstrap.IModalInstanceService | null = null;
        switch (tipoSolicitacao) {
            case TipoSolicitacaoEnum.CANCELAMENTO_BENEFICIO:
                modal = this.CancelamentoModalService.open(beneficioTrabalhador);
                break;
            case TipoSolicitacaoEnum.SUSPENSAO_BENEFICIO:
                modal = this.SuspensaoModalService.open(beneficioTrabalhador);
                break;
            case TipoSolicitacaoEnum.PRORROGACAO_SUSPENSAO_BENEFICIO:
                modal = this.ProrrogacaoModalService.open(beneficioTrabalhador);
                break;
            case TipoSolicitacaoEnum.TROCA_BENEFICIO:
                modal = this.TrocaModalService.open(beneficioTrabalhador);
                break;
            case TipoSolicitacaoEnum.REATIVACAO_BENEFICIO:
                modal = this.ReativacaoModalService.open(beneficioTrabalhador);
                break;
            default:
                modal = null;
                break;
        }
        if (!modal) {
            return;
        }
        modal.result.then((response) => {/**/}).catch(() => {/**/});
    }

    setTiposDeBeneficios(
        beneficiosTrabalhador: IBeneficioTrabalhador[],
        solicitacoesBeneficio: ISolicitacaoBeneficio[]
    ) {
        const keyBeneficiosTrabalhadores = this.setBeneficiosTrabalhadores(beneficiosTrabalhador);
        const keySolicitacoesBeneficio = this.setSolicitacoes(solicitacoesBeneficio);
        const keys = new Set([
            ...keyBeneficiosTrabalhadores,
            ...keySolicitacoesBeneficio
        ]);
        this.tiposDeBeneficiosKeys = Array.from(keys);
    }

    setBeneficiosTrabalhadores(entities: IBeneficioTrabalhador[]) {
        const keys = new Set<TipoBeneficiosEnum>();
        entities.forEach((entity) => {
            const entityCopy = {
                ...entity,
                ...this.setBeneficiario(entity),
                ...this.setSituacaoBeneficio(entity)
            } as IBeneficioTrabalhadorDetalhado;

            if (entityCopy.situacaoBeneficio && TipoBeneficiosEnum[entityCopy.tipobeneficiointerno.tipobeneficiointerno]) {
                this.tiposDeBeneficios[entityCopy.tipobeneficiointerno.tipobeneficiointerno].beneficiostrabalhador.push(entityCopy);
                keys.add(entityCopy.tipobeneficiointerno.tipobeneficiointerno);
            }
        });
        return Array.from(keys);
    }

    setSolicitacoes(entities: ISolicitacaoBeneficio[]) {
        const keys = new Set<TipoBeneficiosEnum>();
        entities.forEach((entity) => {
            const entityCopy = {
                ...entity,
                ...this.setBeneficiario(entity)
            } as ISolicitacaoBeneficio & IBeneficiario;

            if (TipoBeneficiosEnum[entityCopy.tipobeneficiointerno]) {
                this.tiposDeBeneficios[entityCopy.tipobeneficiointerno].solicitacoes.push(entityCopy);
                keys.add(entityCopy.tipobeneficiointerno);
            }
        });
        return Array.from(keys);
    }

    setSituacaoBeneficio(beneficiotrabalhador: IBeneficioTrabalhador) {
        const currentDate = moment().startOf('day');
        const dataAdesao = moment(beneficiotrabalhador.dataadesao, 'YYYY-MM-DD');

        if (currentDate.isBefore(dataAdesao)) {
            return {
                situacaoBeneficio: SituacaoBeneficioEnum.ATIVO,
                adesaoFutura: true
            };
        }

        if (beneficiotrabalhador.ultima_suspensao) {
            const inicioSuspensao = moment(beneficiotrabalhador.ultima_suspensao.datainicio, 'YYYY-MM-DD');
            const fimSuspensao = moment(beneficiotrabalhador.ultima_suspensao.datafim, 'YYYY-MM-DD');
            if (currentDate.isBetween(inicioSuspensao, fimSuspensao, undefined, '[]')) {
                return { situacaoBeneficio: SituacaoBeneficioEnum.SUSPENSO };
            }
        }

        if (beneficiotrabalhador.ultima_adesao) {
            const ultimaDataAdesao = moment(beneficiotrabalhador.ultima_adesao.dataadesao, 'YYYY-MM-DD');
            if (currentDate.isBefore(ultimaDataAdesao)) {
                return {
                    situacaoBeneficio: SituacaoBeneficioEnum.ATIVO,
                    adesaoFutura: true
                };
            }
            if (beneficiotrabalhador.ultima_adesao.dataexclusao) {
                const ultimaDataExclusao = moment(beneficiotrabalhador.ultima_adesao.dataexclusao, 'YYYY-MM-DD');
                if (currentDate.isBetween(ultimaDataAdesao, ultimaDataExclusao, undefined, '[]')) {
                    return { situacaoBeneficio: SituacaoBeneficioEnum.ATIVO };
                } else {
                    return { situacaoBeneficio: SituacaoBeneficioEnum.CANCELADO };
                }
            }
            return { situacaoBeneficio: SituacaoBeneficioEnum.ATIVO };
        }

        if (beneficiotrabalhador.dataexclusao) {
            const dataExclusao = moment(beneficiotrabalhador.dataexclusao, 'YYYY-MM-DD');
            if (currentDate.isBetween(dataAdesao, dataExclusao, undefined, '[]')) {
                return { situacaoBeneficio: SituacaoBeneficioEnum.ATIVO };
            } else {
                return { situacaoBeneficio: SituacaoBeneficioEnum.CANCELADO };
            }
        }

        return { situacaoBeneficio: SituacaoBeneficioEnum.ATIVO };
    }

    setBeneficiario(entity: ITrabalhadorDependente) {
        return {
            beneficiario: entity.dependentetrabalhador?.dependentetrabalhador ?
            {
                ...entity.dependentetrabalhador,
                beneficiario: entity.dependentetrabalhador.dependentetrabalhador
            } : {
                ...entity.trabalhador,
                beneficiario: entity.trabalhador.trabalhador
            }
        };
    }

    setTiposBeneficios() {
        const obj = {} as ITiposDeBeneficios;
        Object.values(TipoBeneficiosEnum)
            .filter((v) => !isNaN(Number(v)))
            .map(key => {
                obj[key] = {
                    solicitacoes: [],
                    beneficiostrabalhador: []
                };
            });
        return obj;
    }

    hasSolicitacao(beneficiario: IBeneficiario['beneficiario'], keyTipoBeneficio: TipoBeneficiosEnum, tipoSolicitacao: TipoSolicitacaoEnum) {
        const hasSolicitacao: boolean = this.tiposDeBeneficios[keyTipoBeneficio]
            .solicitacoes.some((solicitacao) => {
                return solicitacao.beneficiario.beneficiario === beneficiario.beneficiario &&
                    solicitacao.tiposolicitacao === tipoSolicitacao;
            });
        return hasSolicitacao;
    }

    setInclusaoBtnVisible(tipoBeneficiosDisponiveis: TipoBeneficiosEnum[]) {
        const obj = {
            visible: false,
            items: {} as { [key in TipoBeneficiosEnum]: boolean }
        };
        tipoBeneficiosDisponiveis.forEach(elem => {
            obj.items[elem] = !this.tiposDeBeneficios[elem]
                .solicitacoes.some((solicitacao) => {
                    return solicitacao.tiposolicitacao === TipoSolicitacaoEnum.INCLUSAO_BENEFICIO;
                });
            if (obj.items[elem]) {
                obj.visible = obj.items[elem];
            }
        });
        return obj;
    }

    toggleFilterAtivos(checked: boolean) {
        if (checked) {
            this.filterAtivos['situacaoBeneficio'] = SituacaoBeneficioEnum.ATIVO;
        } else {
            this.filterAtivos = {};
        }
    }
}
